import { useRef, useMemo } from "react";
import { Libraries, useJsApiLoader } from "@react-google-maps/api";

export const useGoogleMapsAutocomplete = () => {
  const autocompleteAddressRef = useRef<google.maps.places.Autocomplete | null>(
    null
  );
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!;

  const libraries: Libraries = useMemo(() => ["places"], []);
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey,
    version: "3.55",
    libraries,
  });

  return {
    autocompleteAddressRef,
    isLoaded,
    loadError,
  };
};
